import { render, staticRenderFns } from "./delivery-express.vue?vue&type=template&id=4dea4dc9&scoped=true"
import script from "./delivery-express.vue?vue&type=script&lang=js"
export * from "./delivery-express.vue?vue&type=script&lang=js"
import style0 from "./delivery-express.vue?vue&type=style&index=0&id=4dea4dc9&prod&lang=scss&scoped=true"
import style1 from "./delivery-express.vue?vue&type=style&index=1&id=4dea4dc9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dea4dc9",
  null
  
)

export default component.exports